import { DataService } from './dataService'


const CourierPartnerService = {
    getCourierPartnerList: async (data) => {
        return DataService.get('/admin/courier-partners', data)
    },
    editCourierPartner: async (data) => {
        return DataService.put('/admin/courier-partners', data)
    },
    addCourierPartner: async (data) => {
        return DataService.post('/admin/courier-partners', data)
    },
    assignCourierPartner: async (data) => {
        return DataService.post('/admin/assign-courier-partner', data)
    },
    getCourierPartnerLabel: async (data) => {
        return DataService.get('/admin/marketplace-get-label', data)
    },

}


export default CourierPartnerService